module.exports = __webpack_public_path__ + "static/media/april.c79a06ed.svg";